export default __webpack_public_path__ + "static/media/tutorial04.24fb51be.jpg";